/* GENERATED FILE. Do not edit.
   Source: the sofa dimensions feed, https://cdn.sophieconran.com/api/dimensions,
           which serves the figures in the product SSOT sheet.
   Regenerate: node tools/sync-fit-dimensions.js (from the theme repo)
   Edits made here are lost the next time that runs. To change a figure,
   change it in the sheet.

   This is the Will it fit? tool's offline copy of that feed: what the
   page paints from before the live feed answers, and what it keeps if the
   feed cannot be reached. UK figures are centimetres and US figures are
   inches, each rounded up to one decimal place by the feed. */
window.SC = window.SC || {};
window.SC.fitDimensions = {
  "version": 1,
  "generatedAt": "2026-10-13T13:19:05.083Z",
  "markets": {
    "UK": {
      "unit": "cm",
      "ranges": [
        {
          "key": "coco",
          "name": "Coco",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 90, "h": 76, "d": 95, "access": 68, "feet": 8 },
            { "key": "loveseat", "label": "Loveseat", "w": 140, "h": 76, "d": 102, "access": 68, "feet": 8 },
            { "key": "2-seater", "label": "2 Seater", "w": 167, "h": 76, "d": 102, "access": 68, "feet": 8 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 196, "h": 76, "d": 102, "access": 68, "feet": 8 },
            { "key": "3-seater", "label": "3 Seater", "w": 224, "h": 76, "d": 102, "access": 68, "feet": 8 },
            { "key": "3.5-seater", "label": "3.5 Seater", "w": 251, "h": 76, "d": 102, "access": 68, "feet": 8 },
            { "key": "4-seater", "label": "4 Seater", "w": 279, "h": 76, "d": 102, "access": 68, "feet": 8 },
            { "key": "4.5-seater", "label": "4.5 Seater", "w": 307, "h": 76, "d": 102, "access": 68, "feet": 8 }
          ]
        },
        {
          "key": "coco-sofa-bed",
          "name": "Coco Sofa Bed",
          "type": "sofabed",
          "split": false,
          "detachable": true,
          "frameDesign": ["Single Frame (no split)", "Can be made in sectional parts (detachable arms and back)"],
          "sizes": [
            { "key": "armchair-small-loveseat", "label": "Armchair / Small Loveseat", "w": 120, "h": 76, "d": 102, "access": 76, "feet": 6 },
            { "key": "loveseat", "label": "Loveseat", "w": 160, "h": 76, "d": 102, "access": 76, "feet": 6 },
            { "key": "2-seater", "label": "2 Seater", "w": 180, "h": 76, "d": 102, "access": 76, "feet": 6 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 200, "h": 76, "d": 102, "access": 76, "feet": 6 }
          ]
        },
        {
          "key": "barton",
          "name": "Barton",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "loveseat", "label": "Loveseat", "w": 152, "h": 76, "d": 120, "access": 70, "feet": 6 },
            { "key": "2-seater", "label": "2 Seater", "w": 207, "h": 76, "d": 120, "access": 70, "feet": 6 },
            { "key": "3-seater", "label": "3 Seater", "w": 234, "h": 76, "d": 120, "access": 70, "feet": 6 }
          ]
        },
        {
          "key": "isobel",
          "name": "Isobel",
          "type": "sofa",
          "split": true,
          "detachable": true,
          "frameDesign": ["Single Frame (no split)", "Split Frame", "Detachable Arms (component parts)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 88, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "loveseat", "label": "Loveseat", "w": 116, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "2-seater", "label": "2 Seater", "w": 140, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 168, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "3-seater", "label": "3 Seater", "w": 196, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "3.5-seater", "label": "3.5 Seater", "w": 224, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "4-seater", "label": "4 Seater", "w": 252, "h": 90, "d": 105, "access": 80, "feet": 10 }
          ]
        },
        {
          "key": "felix",
          "name": "Felix",
          "type": "sofa",
          "split": true,
          "detachable": true,
          "frameDesign": ["Single Frame (no split)", "Split Frame", "Detachable Arms (component parts)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 88, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "loveseat", "label": "Loveseat", "w": 116, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "2-seater", "label": "2 Seater", "w": 140, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 168, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "3-seater", "label": "3 Seater", "w": 196, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "3.5-seater", "label": "3.5 Seater", "w": 224, "h": 90, "d": 105, "access": 80, "feet": 10 },
            { "key": "4-seater", "label": "4 Seater", "w": 252, "h": 90, "d": 105, "access": 80, "feet": 10 }
          ]
        },
        {
          "key": "henrietta",
          "name": "Henrietta",
          "type": "sofa",
          "split": false,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 105, "h": 92, "d": 94, "access": 92, "feet": 21 },
            { "key": "loveseat", "label": "Loveseat", "w": 127, "h": 92, "d": 94, "access": 92, "feet": 21 },
            { "key": "2-seater", "label": "2 Seater", "w": 155, "h": 92, "d": 94, "access": 92, "feet": 21 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 182.9, "h": 92, "d": 94, "access": 92, "feet": 21 },
            { "key": "3-seater", "label": "3 Seater", "w": 210, "h": 92, "d": 94, "access": 92, "feet": 21 }
          ]
        },
        {
          "key": "sophia",
          "name": "Sophia",
          "type": "sofa",
          "split": false,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 73, "h": 88.5, "d": 82, "access": 88.5, "feet": 29 },
            { "key": "2-seater", "label": "2 Seater", "w": 134, "h": 88.5, "d": 82, "access": 88.5, "feet": 29 },
            { "key": "3-seater", "label": "3 Seater", "w": 194, "h": 88.5, "d": 82, "access": 88.5, "feet": 29 }
          ]
        },
        {
          "key": "cocobella",
          "name": "Cocobella",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 88, "h": 82, "d": 97, "access": 73.5, "feet": 8.5 },
            { "key": "loveseat", "label": "Loveseat", "w": 127, "h": 82, "d": 97, "access": 73.5, "feet": 8.5 },
            { "key": "2-seater", "label": "2 Seater", "w": 166, "h": 82, "d": 97, "access": 73.5, "feet": 8.5 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 196, "h": 82, "d": 97, "access": 73.5, "feet": 8.5 },
            { "key": "3-seater", "label": "3 Seater", "w": 226, "h": 82, "d": 97, "access": 73.5, "feet": 8.5 },
            { "key": "3.5-seater", "label": "3.5 Seater", "w": 256, "h": 82, "d": 97, "access": 73.5, "feet": 8.5 }
          ]
        },
        {
          "key": "felix-for-john-lewis",
          "name": "Felix for John Lewis",
          "type": "sofa",
          "split": false,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 85, "h": 86, "d": 110, "access": 81, "feet": 5 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 175, "h": 86, "d": 110, "access": 81, "feet": 5 },
            { "key": "3-seater", "label": "3 Seater", "w": 200, "h": 86, "d": 110, "access": 81, "feet": 5 }
          ]
        },
        {
          "key": "salthrop",
          "name": "Salthrop",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "loveseat", "label": "Loveseat", "w": 152, "h": 78, "d": 119, "access": 73, "feet": 5 },
            { "key": "2-seater", "label": "2 Seater", "w": 207, "h": 78, "d": 119, "access": 73, "feet": 5 },
            { "key": "3-seater", "label": "3 Seater", "w": 237, "h": 78, "d": 119, "access": 73, "feet": 5 }
          ]
        }
      ]
    },
    "US": {
      "unit": "in",
      "ranges": [
        {
          "key": "coco",
          "name": "Coco",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 35.5, "h": 30, "d": 37.5, "access": 26.8, "feet": 3.2 },
            { "key": "loveseat", "label": "Loveseat", "w": 55.2, "h": 30, "d": 40.2, "access": 26.8, "feet": 3.2 },
            { "key": "2-seater", "label": "2 Seater", "w": 65.8, "h": 30, "d": 40.2, "access": 26.8, "feet": 3.2 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 77.2, "h": 30, "d": 40.2, "access": 26.8, "feet": 3.2 },
            { "key": "3-seater", "label": "3 Seater", "w": 88.2, "h": 30, "d": 40.2, "access": 26.8, "feet": 3.2 },
            { "key": "3.5-seater", "label": "3.5 Seater", "w": 98.9, "h": 30, "d": 40.2, "access": 26.8, "feet": 3.2 },
            { "key": "4-seater", "label": "4 Seater", "w": 109.9, "h": 30, "d": 40.2, "access": 26.8, "feet": 3.2 }
          ]
        },
        {
          "key": "coco-sofa-bed",
          "name": "Coco Sofa Bed",
          "type": "sofabed",
          "split": false,
          "detachable": true,
          "frameDesign": ["Single Frame (no split)", "Detached arms for easy access"],
          "sizes": [
            { "key": "loveseat", "label": "Loveseat", "w": 63, "h": 30, "d": 40.2, "access": 30, "feet": 3.2 },
            { "key": "2-seater", "label": "2 Seater", "w": 70.9, "h": 30, "d": 40.2, "access": 30, "feet": 3.2 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 78.8, "h": 30, "d": 40.2, "access": 30, "feet": 3.2 }
          ]
        },
        {
          "key": "barton",
          "name": "Barton",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "loveseat", "label": "Loveseat", "w": 60, "h": 30, "d": 47.3, "access": 27.6, "feet": 2.4 },
            { "key": "2-seater", "label": "2 Seater", "w": 81, "h": 30, "d": 47.3, "access": 27.6, "feet": 2.4 },
            { "key": "3-seater", "label": "3 Seater", "w": 92.2, "h": 30, "d": 47.3, "access": 27.6, "feet": 2.4 }
          ]
        },
        {
          "key": "isobel",
          "name": "Isobel",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "Split Frame"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 29.6, "h": 33.1, "d": 41.8, "access": 30.8, "feet": 6 },
            { "key": "loveseat", "label": "Loveseat", "w": 43, "h": 33.1, "d": 41.8, "access": 30.8, "feet": 6 },
            { "key": "2-seater", "label": "2 Seater", "w": 54.8, "h": 33.1, "d": 41.8, "access": 30.8, "feet": 6 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 67.4, "h": 33.1, "d": 41.8, "access": 30.8, "feet": 6 },
            { "key": "3-seater", "label": "3 Seater", "w": 77.2, "h": 33.1, "d": 41.8, "access": 30.8, "feet": 6 },
            { "key": "4-seater", "label": "4 Seater", "w": 90.2, "h": 33.1, "d": 41.8, "access": 30.8, "feet": 6 }
          ]
        },
        {
          "key": "felix",
          "name": "Felix",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "Split Frame"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 29.6, "h": 33.1, "d": 39, "access": 29, "feet": 6 },
            { "key": "loveseat", "label": "Loveseat", "w": 43, "h": 33.1, "d": 39, "access": 29, "feet": 6 },
            { "key": "2-seater", "label": "2 Seater", "w": 54.8, "h": 33.1, "d": 39, "access": 29, "feet": 6 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 67.4, "h": 33.1, "d": 39, "access": 29, "feet": 6 },
            { "key": "3-seater", "label": "3 Seater", "w": 77.2, "h": 33.1, "d": 39, "access": 29, "feet": 6 },
            { "key": "4-seater", "label": "4 Seater", "w": 90.2, "h": 33.1, "d": 39, "access": 29, "feet": 6 }
          ]
        },
        {
          "key": "henrietta",
          "name": "Henrietta",
          "type": "sofa",
          "split": false,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 41.4, "h": 36.3, "d": 37, "access": 36.3, "feet": 8.3 },
            { "key": "loveseat", "label": "Loveseat", "w": 50, "h": 36.3, "d": 37, "access": 36.3, "feet": 8.3 },
            { "key": "2-seater", "label": "2 Seater", "w": 61, "h": 36.3, "d": 37, "access": 36.3, "feet": 8.3 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 72, "h": 36.3, "d": 37, "access": 36.3, "feet": 8.3 },
            { "key": "3-seater", "label": "3 Seater", "w": 82.7, "h": 36.3, "d": 37, "access": 36.3, "feet": 8.3 }
          ]
        },
        {
          "key": "sophia",
          "name": "Sophia",
          "type": "sofa",
          "split": false,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 28.8, "h": 34.9, "d": 32.3, "access": 34.9, "feet": 11.5 },
            { "key": "2-seater", "label": "2 Seater", "w": 52.8, "h": 34.9, "d": 32.3, "access": 34.9, "feet": 11.5 },
            { "key": "3-seater", "label": "3 Seater", "w": 76.4, "h": 34.9, "d": 32.3, "access": 34.9, "feet": 11.5 }
          ]
        },
        {
          "key": "cocobella",
          "name": "Cocobella",
          "type": "sofa",
          "split": true,
          "detachable": false,
          "frameDesign": ["Single Frame (no split)", "1-Split Frame (2 sections)"],
          "sizes": [
            { "key": "armchair", "label": "Armchair", "w": 34.3, "h": 31.5, "d": 38.2, "access": 29.2, "feet": 2.4 },
            { "key": "loveseat", "label": "Loveseat", "w": 50, "h": 31.5, "d": 38.2, "access": 29.2, "feet": 2.4 },
            { "key": "2-seater", "label": "2 Seater", "w": 65.4, "h": 31.5, "d": 38.2, "access": 29.2, "feet": 2.4 },
            { "key": "2.5-seater", "label": "2.5 Seater", "w": 77.2, "h": 31.5, "d": 38.2, "access": 29.2, "feet": 2.4 },
            { "key": "3-seater", "label": "3 Seater", "w": 89, "h": 31.5, "d": 38.2, "access": 29.2, "feet": 2.4 },
            { "key": "3.5-seater", "label": "3.5 Seater", "w": 100.8, "h": 31.5, "d": 38.2, "access": 29.2, "feet": 2.4 }
          ]
        }
      ]
    }
  },
  "rejected": [
    { "market": "US", "range": "Isobel", "size": "Verified Measurements", "reason": "External Width is missing" }
  ]
};
